module.exports = __webpack_public_path__ + "img/adf-logo.20469190.svg";